module.exports = __webpack_public_path__ + "static/media/photo-3.a250f71b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/sussex-street-mixed-use/photo-3.jpg
// module id = 166
// module chunks = 0